import React, {useEffect} from "react";
import {useNavigate, useParams} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {fetchProductById, editProduct} from "../../store/product-slice";
import {productSchema} from "../../schema/productSchema";
import {getFormData} from "../../models/productModel";
import SubHeader from "../../components/header/SubHeader";
import Button from "../../components/common/button/Button";
import Form from "../../components/common/form/Form";
import {Role} from "../../enums/enums";
import {fetchTagList} from "../../store/list-slice";
import {getValidatedLimit} from "../../components/Utility";
import {Status} from "../../enums/enums";

const ProductEdit = () => {
    const params = useParams();
    const navigator = useNavigate();
    const dispatch = useDispatch();
    const {pagination} = useSelector(state => state.product);
    const {limit, currentPage} = getValidatedLimit(pagination);

    const {
        items,
        editStatus,
        fetchByIdStatus,
        error
    } = useSelector(state => state.product);

    const userRole = useSelector((state) => state.auth.selectedRole);
    const list = useSelector(state => state.list);

    useEffect(() => {
        dispatch(fetchProductById(
            {
                ...userRole,
                id: params.productId
            }
        ));
    }, [dispatch, params.productId, userRole]);

    const product = items.find(item => item.id === params.productId);

    const updatedProduct = product
        ? {
            ...product,
            tags: product.tags.map(tagObj =>
                Object.values(tagObj).find(val => typeof val === 'string' && /^[a-f0-9]{24}$/i.test(val))
            ).filter(Boolean)
        }
        : null;  //


    useEffect(() => {
        if (editStatus === "success") {
            navigator(`../../?page=${currentPage}&limit=${limit}`);
        }
    }, [editStatus, navigator, currentPage, limit]);

    const formSubmitHandler = (data) => {
        dispatch(editProduct(
            {
                ...userRole,
                data,
                id: params.productId,
            }
        ));
    };

    const formCancelHandler = () => {
        navigator(`../../?page=${currentPage}&limit=${limit}`);
    };

    useEffect(() => {
        dispatch(fetchTagList(userRole));
    }, [dispatch, userRole]);

    const schema = productSchema({list, Status});
    if (userRole.role === Role.Manager) {
        delete schema.name;
        delete schema.image;
        delete schema.status;
        delete schema.description;
    }
    else if(userRole.scope === "Restaurant"){
        delete schema.availability
    }

    const initialData = getFormData(updatedProduct);

    return (
        <>
            <SubHeader title="Update Product">
                <Button to={`../../?page=${currentPage}&limit=${limit}`}
                        className="btn-sm bg-secondary bg-opacity-50">Back</Button>
            </SubHeader>
            <div className="container p-0 ms-0">
                <div className="row">
                    <div className="col-xl-6">
                        {fetchByIdStatus === "loading" && <p>Loading...</p>}
                        {fetchByIdStatus === "failed" && <h6 className="text-danger">{error}</h6>}
                        {fetchByIdStatus === "success" &&
                            <Form onFormSubmit={formSubmitHandler}
                                  onFormCancel={formCancelHandler}
                                  schema={schema}
                                  inline={false}
                                  initialData={initialData}
                                  status={editStatus}
                                  error={error}/>
                        }
                    </div>
                </div>
            </div>
        </>
    );
};

export default ProductEdit;
